"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadinessCheckerAudioTest = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _ReadinessCheckerAudioTest = require("./ReadinessCheckerAudioTest.styled");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _environment = require("@studio/environment");
var _metrics = require("@studio/metrics");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ReadinessCheckerAudioTest = exports.ReadinessCheckerAudioTest = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var _iconMap, _buttonMap;
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$audioDeviceId = _ref.audioDeviceId,
    audioDeviceId = _ref$audioDeviceId === void 0 ? '' : _ref$audioDeviceId;
  var _useCommonPageActions = (0, _metrics.useCommonPageActionsApi)(),
    testAudioButtonClicked = _useCommonPageActions.testAudioButtonClicked;
  var audioStatuses = {
    STOPPED: 'STOPPED',
    PLAYING: 'PLAYING'
  };
  var iconMap = (_iconMap = {}, (0, _defineProperty2["default"])(_iconMap, audioStatuses.STOPPED, _freeSolidSvgIcons.faPlay), (0, _defineProperty2["default"])(_iconMap, audioStatuses.PLAYING, _freeSolidSvgIcons.faStop), _iconMap);
  var _useState = (0, _react.useState)(audioStatuses.STOPPED),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    audioStatus = _useState2[0],
    setAudioStatus = _useState2[1];
  var vidRef = (0, _react.useRef)(null);
  var handlePlayVideo = function handlePlayVideo() {
    vidRef.current.setSinkId(audioDeviceId);
    vidRef.current.play();
    testAudioButtonClicked();
    setAudioStatus(audioStatuses.PLAYING);
  };
  var handleStopVideo = function handleStopVideo() {
    vidRef.current.pause();
    vidRef.current.currentTime = 0;
    setAudioStatus(audioStatuses.STOPPED);
  };
  var buttonMap = (_buttonMap = {}, (0, _defineProperty2["default"])(_buttonMap, audioStatuses.STOPPED, handlePlayVideo), (0, _defineProperty2["default"])(_buttonMap, audioStatuses.PLAYING, handleStopVideo), _buttonMap);
  var handleStoppedVideo = function handleStoppedVideo() {
    setAudioStatus(audioStatuses.STOPPED);
  };
  (0, _react.useEffect)(function () {
    if (vidRef && vidRef.current) {
      vidRef.current.addEventListener('ended', handleStoppedVideo);
    }
    return function () {
      if (vidRef && vidRef.current) {
        vidRef.current.removeEventListener('ended', handleStoppedVideo);
      }
    };
  }, [vidRef]);
  var testAudioSound = (0, _environment.getEnvVar)('REACT_APP_STATIC_ASSETS_BASE_URL') + 'testAudioSound.mp4';
  var tooltipTextMap = (0, _defineProperty2["default"])({}, audioStatuses.STOPPED, 'Test audio to make sure you can hear others');
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerAudioTest.StyledAudioPlayerWrapper, {
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerAudioTest.StyleVideoWrapper, null, /*#__PURE__*/_react["default"].createElement("video", {
    ref: vidRef,
    src: testAudioSound,
    "aria-label": "Readiness checker sound test"
  }, "Your browser does not support the video file")), /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerAudioTest.StyledButton, {
    title: tooltipTextMap[audioStatus],
    "data-dd-action-name": "Readiness Checker audio test initiated",
    "aria-label": "Click to listen to readiness checker sound test",
    color: "light",
    variant: "outlined",
    onClick: buttonMap[audioStatus],
    "data-testid": "playButton",
    disabled: disabled,
    id: "playButton",
    icon: iconMap[audioStatus]
  }), audioStatus === audioStatuses.STOPPED && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    "data-testid": "tooltip",
    placement: "top",
    target: "playButton"
  }, tooltipTextMap[audioStatus]));
});
ReadinessCheckerAudioTest.propTypes = {
  disabled: _propTypes["default"].bool,
  audioDeviceId: _propTypes["default"].string
};